import { SUPPLIES_PROMOTION_ATTRIBUTE } from "./cart-attributes";

/** The parts of a cart line that decide what it contributes in money. */
export interface ValuedCartLine {
  price: number;
  quantity: number;
  attributes: readonly { key: string }[];
}

/** Whether a line is a promotion's free item rather than something paid for. */
export function isFreeLine(item: ValuedCartLine): boolean {
  return item.attributes.some(
    (attribute) => attribute.key === SUPPLIES_PROMOTION_ATTRIBUTE,
  );
}

/**
 * Cart value from paid lines only, minor units. Free promo lines are worth
 * nothing, so they neither earn a promotion nor absorb a discount.
 */
export function paidCartValue(items: readonly ValuedCartLine[]): number {
  return items
    .filter((item) => !isFreeLine(item))
    .reduce((sum, item) => sum + item.price * item.quantity, 0);
}

/** A cart's lines plus whatever discount is currently applying to them. */
export interface DiscountedCart {
  items: readonly ValuedCartLine[];
  appliedDiscount?: { active: boolean; amount: number } | null;
}

/**
 * Value a promotion's threshold is measured against: paid lines less an active
 * discount, so a code that drops the cart under the bar forfeits the free item.
 */
export function qualifyingCartValue(cart: DiscountedCart): number {
  const discount = cart.appliedDiscount?.active
    ? cart.appliedDiscount.amount
    : 0;
  return paidCartValue(cart.items) - discount;
}
